import './newsletter-sign-up.scss'
import type { EmailAvailability } from '@vista-digital/ocapi-types/v1'
import { MemberEmailCheckerFormComponent, MemberEmailCheckerFormFieldComponent } from '@vista-digital/occ-ui'
import { MemberEmailCheckerFormFieldName } from '@vista-digital/occ-ui/src/lib/components/member/email-checker-form-field/types/name'
import type { FC } from 'react'
import { signInModalStore } from '@/common/components/signInModal/signInModal.store'
import { useGetMember } from '@/common/hooks/useGetMember'
import { redirectService } from '@/common/redirect.service'
import { cmsDataService } from '@/common/services/cms.data.service'
import { navigationService } from '@/common/services/navigation.service'

export interface NewsletterSignUpProps {
    className?: string
    /**
     * Indicates whether the component should render in a responsive layout on from tablet breakpoint and up,
     * since this `NewsletterSignUp` component is not responsive on footer
     */
    isResponsive?: boolean
}

export const NewsletterSignUp: FC<NewsletterSignUpProps> = props => {
    const { className, isResponsive } = props
    const { isSignedIn } = useGetMember()
    const { title, emailPlaceholder, signUpButtonLabel, errorEmailFormatMessage, errorApiFailedMessage } =
        cmsDataService.get().footer.newsletterSignUp
    // ( to confirm) might need to move this or use a different newsletter config per page

    /*
     * is user signed in and already member -> Communication preferences page
     * is user found, show SignInModal
     * is user not found, redirect to a SignUp Page
     * */
    const onAfterSuccessfulSubmitHandler = ({ isAvailable }: EmailAvailability) => {
        const isUserFound = !isAvailable // -> isAvailable mean no user uses that email on the auth db
        const navigateToPreferences = () => navigationService.goToPageOrSubPage('Account', 'AccountPreferences')

        if (isSignedIn && isUserFound) {
            navigateToPreferences()
            return
        }

        if (isUserFound) {
            signInModalStore.openSignInModal(() => navigateToPreferences())
            return
        }

        // where to go after signup in  signup-page
        const url = navigationService.getPageUrls('Account', 'AccountPreferences')?.[0] ?? '/'
        redirectService.redirectTo(url)

        navigationService.goToPageOrSubPage('Membership', 'MembershipSignUp')
    }

    return (
        <div className={`newsletter-sign-up ${className} ${isResponsive ? 'responsive' : ''}`}>
            {title && <h5 className="newsletter-heading">{title}</h5>}
            <MemberEmailCheckerFormComponent
                displayText={{ errorEmailFormatMessage, errorApiFailedMessage, submitButtonLabel: signUpButtonLabel }}
                events={{ onAfterSuccessfulSubmit: onAfterSuccessfulSubmitHandler }}
            >
                <MemberEmailCheckerFormFieldComponent
                    name={MemberEmailCheckerFormFieldName.Email}
                    displayText={{ placeholder: emailPlaceholder }}
                />
            </MemberEmailCheckerFormComponent>
        </div>
    )
}
